// Every image in src/assets/images/helpCenter/, keyed by file name (e.g.
// "create-shipment-fig-1.png"), so a figure's backend-sent name resolves to
// its bundled URL.
const modules = import.meta.glob(
  '../../../../assets/images/helpCenter/*.{png,jpg,jpeg,svg,webp}',
  { eager: true, import: 'default' }
) as Record<string, string>;

export const helpCenterImages: Record<string, string> = Object.fromEntries(
  Object.entries(modules).map(([path, url]) => [path.split('/').pop(), url])
);
